import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { liveQuery } from 'dexie';
import { from } from 'rxjs';
import { db } from '../database/db';
import EntityManager, { POLLING_DEFAULT_CONFIG } from '../database/EntityManager';
import { Location } from '../database/models';

@Injectable({
  providedIn: 'root',
})
export class LocationsService extends EntityManager<Location, 'location'> {
  public values$ = from(
    liveQuery(async () => {
      //TODO: put under behavior into Entity Manager.
      // Do not emit values until the API has returned a response.
      const res = await db._configuration.get({ name: this.name });
      let devices: Location[] = null;
      if (res) {
        devices = await this.getAll();
      }

      return devices;
    })
  );
  public $values = toSignal(this.values$);

  constructor() {
    super({
      name: 'location',
      model: Location,
      polling: { duration: POLLING_DEFAULT_CONFIG.duration, retrieveDelta: true },
    });
  }
}
